/**
 * ScrollToTop — reset window scroll on navigation.
 *
 * React Router keeps the previous scroll position when you navigate to a new
 * route, so landing on a fresh page can leave you stranded halfway down. Mounted
 * once inside <BrowserRouter>, this snaps the window back to the top whenever the
 * path changes. If the URL carries a #hash anchor we leave scrolling alone so
 * in-page links still work.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let anchor links jump to their target
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
